import React from 'react'
import PropTypes from 'prop-types'
import {
  AutocompleteStyle,
  FormError,
  InputBaseStyle,
  TextFieldModalStyle,
  TextFieldStyle
} from '../../Deal.style'
import PaperAutoComplete from '../../../../components/PaperAutoComplete/PaperAutoComplete'
import NumericFormatModal from '../../../../components/ModalApp/components/NumericFormatModal/NumericFormatModal'
import { CheckboxStyle, Label } from '../../../../components/styled/global.style'
import { Box, Typography } from '@mui/material'
import { ButtonGroupStyle, OptionContainer, OptionCounterparty, SideButton } from '../../Deal.style'
import { FormControlLabelStyle } from '../../../Entities/Entities.style'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'

const NdfDeal = ({
  clients,
  fixingSource,
  marketMakers,
  sides,
  handelFormChange,
  form,
  handelFocusCurrencyPair,
  handelBlurCurrencyPair,
  checkPrimeBrokerIsRBS,
  errors,
  handelDateChange
}) => {
  return (
    <>
      <Box></Box>
      <Box width={'100%'}>
        <Label>Client *</Label>
        {Array.isArray(clients.data) && (
          <AutocompleteStyle
            onChange={(event, element) => {
              event.target.name = 'client'
              element = element ?? ''
              handelFormChange(event, element)
            }}
            size={'small'}
            value={form.client}
            options={clients.data.map(({ name }) => name)}
            renderOption={(props, option) => {
              return (
                <OptionContainer {...props} key={option}>
                  <Typography>{option.split(' ').slice(0, -1).join(' ')} </Typography>
                  <OptionCounterparty>{option.split(' ').at(-1)} </OptionCounterparty>
                </OptionContainer>
              )
            }}
            renderInput={params => (
              <TextFieldModalStyle fullWidth {...params} placeholder={'Select Client'} />
            )}
            ListboxComponent={PaperAutoComplete}
          />
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Market Maker *</Label>
        {Array.isArray(marketMakers.data) && (
          <AutocompleteStyle
            onChange={(event, element) => {
              event.target.name = 'market_maker'
              element = element ?? ''
              handelFormChange(event, element)
            }}
            size={'small'}
            value={form.market_maker}
            options={marketMakers.data.map(({ name }) => name)}
            renderOption={(props, option) => {
              return (
                <OptionContainer {...props} key={option}>
                  <Typography>{option.split(' ').slice(0, -1).join(' ')} </Typography>
                  <OptionCounterparty>{option.split(' ').at(-1)} </OptionCounterparty>
                </OptionContainer>
              )
            }}
            renderInput={params => (
              <TextFieldModalStyle fullWidth {...params} placeholder={'Select Market Maker'} />
            )}
            ListboxComponent={PaperAutoComplete}
          />
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Currency Pair *</Label>
        <InputBaseStyle
          value={form.currency_pair}
          name="currency_pair"
          onChange={handelFormChange}
          onFocus={handelFocusCurrencyPair}
          onBlur={handelBlurCurrencyPair}
          error={errors.currency_pair}
        />
        {errors.currency_pair !== '' && <FormError>{errors.currency_pair}</FormError>}
      </Box>
      <Box width={'100%'}>
        <Label>Client Side *</Label>
        {Array.isArray(sides.data) && (
          <ButtonGroupStyle variant="outlined">
            {sides.data.map(({ name }, id) => (
              <SideButton
                name="client_side"
                key={id}
                value={name}
                select={String(form.client_side === name)}
                onClick={handelFormChange}
              >
                {name}
              </SideButton>
            ))}
          </ButtonGroupStyle>
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Quantity *</Label>
        <NumericFormatModal
          value={form.quantity}
          name="quantity"
          handelFormChange={handelFormChange}
          placeholder="0.00"
        />
      </Box>
      <Box width={'100%'}>
        <Label>Trade Date *</Label>
        <TextFieldStyle type="datetime-local" value={form.trade_date} disabled />
      </Box>
      <Box width={'100%'}>
        <Label>Client Value Date *</Label>
        <TextFieldStyle
          type="date"
          name="client_value_date"
          value={form.client_value_date}
          placeholder="dd-mm-yyyy"
          onChange={event => handelDateChange('client_value_date', event.target.value)}
        />
      </Box>
      <Box width={'100%'}>
        <Label>Market Value Date *</Label>
        <TextFieldStyle
          type="date"
          variant="outlined"
          placeholder="dd-mm-yyyy"
          value={form.client_value_date}
        />
      </Box>
      <Box width={'100%'}>
        <Label>Client Price *</Label>
        <InputBaseStyle
          value={form.client_price}
          name="client_price"
          onChange={handelFormChange}
          placeholder="0.0000"
        />
      </Box>
      <Box width={'100%'}>
        <Label>Market Price *</Label>
        <InputBaseStyle
          value={form.market_maker_price}
          name="market_maker_price"
          onChange={handelFormChange}
          placeholder="0.0000"
        />
      </Box>
      <Box width={'100%'}>
        <Label>Fixing Date *</Label>
        <TextFieldStyle
          type="date"
          variant="outlined"
          value={form.fixing_date}
          onChange={event => handelDateChange('fixing_date', event.target.value)}
        />
      </Box>
      <Box width={'100%'}>
        <Label>Fixing Source *</Label>
        {Array.isArray(fixingSource.data) && (
          <AutocompleteStyle
            onChange={(event, element) => {
              event.target.name = 'fixing_source'
              element = element ?? ''
              handelFormChange(event, element)
            }}
            size={'small'}
            value={form.fixing_source}
            options={fixingSource.data.map(({ name }) => name)}
            renderInput={params => (
              <TextFieldModalStyle fullWidth {...params} placeholder="Select Fix Source" />
            )}
            ListboxComponent={PaperAutoComplete}
          />
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Client Note</Label>
        <InputBaseStyle value={form.client_note} name="client_note" onChange={handelFormChange} />
      </Box>
      <Box width={'100%'}>
        <Label>Market Note</Label>
        <InputBaseStyle
          value={form.market_maker_note}
          name="market_maker_note"
          onChange={handelFormChange}
        />
      </Box>
      {checkPrimeBrokerIsRBS && (
        <>
          <Box width={'100%'}>
            <Label>Bdr</Label>
            <InputBaseStyle value={form.bdr} name="bdr" onChange={handelFormChange} />
          </Box>
          <Box
            style={{
              display: 'flex',
              margin: 'inherit'
            }}
          >
            <FormControlLabelStyle
              style={{ color: 'white' }}
              onChange={handelFormChange}
              name="is_pba"
              control={
                <CheckboxStyle
                  style={{ marginRight: '8px' }}
                  checked={form.is_pba}
                  icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                  checkedIcon={<CheckBoxIcon fontSize="small" />}
                />
              }
              label="PBA"
            />
          </Box>
        </>
      )}
    </>
  )
}

export default NdfDeal

NdfDeal.propTypes = {
  form: PropTypes.object,
  fixingSource: PropTypes.object,
  marketMakers: PropTypes.object,
  sides: PropTypes.object,
  clients: PropTypes.object,
  handelFormChange: PropTypes.func,
  handelFocusCurrencyPair: PropTypes.func,
  handelBlurCurrencyPair: PropTypes.func,
  errors: PropTypes.object,
  handelDateChange: PropTypes.func,
  checkPrimeBrokerIsRBS: PropTypes.bool
}
